module.exports = "/static-assets/_next/static/images/Poloaroid-4-b1485054c0ab91ee167998d97767d228.png";